/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { memo, useEffect, useState } from "react";
import { Card, CardBody, Col, Row, Button, Spinner } from "reactstrap";
import DataTable from "../../../../shared/components/DataTable";
import { connect } from "react-redux";
import CardStatementSearchForm from "./CardStatementSearchForm";
import {
  searchCardStatement,
  downloadCardStatement,
  resetStatements,
  resetStatementDownload,
  pdfDownloadCardStatement,
  pdfResetStatementDownload,
} from "../../actions/cardStatements.actions";
//import { MdFileDownload } from "react-icons/md";
import { AiFillFileExcel, AiFillFilePdf } from "react-icons/ai";
import { permissionsConstants } from "../../../../constants/permissions.constants";
import AccessControl from "../../../../shared/components/AccessControl";
import CardStatementSearchByProgramForm from "./CardStatementsByProgramForm";
// import renderSelectField from "../../../../shared/components/form/Select";
import Select from "react-select";
const options = [
  { label: "Card Number", value: 1 },
  { label: "Card Program", value: 2 },
  { label: "Issuer", value: 3 },
];

const nonIssuerOptions = [
  { label: "Card Number", value: 1 },
  { label: "Card Program", value: 2 },
];

const CardStatementTable = memo(
  ({
    permissions,
    dispatch,
    cardStatement,
    cardStatementDownload,
    pdfFormatDownload,
  }) => {
    const [formsDisplay, setFormsDisplay] = useState(1);
    // const [cvsLoading, setCsvLoading] = useState(false);
    // const [pdfLoading, setPdfLoading] = useState(false);
    useEffect(() => {
      return () => {
        dispatch(resetStatements());
        dispatch(resetStatementDownload());
        dispatch(pdfResetStatementDownload());
      };
    }, [dispatch]);

    const count =
      cardStatement && cardStatement.response
        ? cardStatement.response.count
        : 0;

    const cardStatementData =
      cardStatement && cardStatement.response
        ? cardStatement.response.content
        : [];

    const columns = [
      {
        accessor: "tranTypeDescription",
        name: "Description",
        sortable: true,
        filterable: true,
        sortKey: "tranTypeDescription",
      },
      {
        accessor: "cardAcceptorNameLoc",
        name: "Location",
        sortable: true,
        filterable: true,
        sortKey: "cardAcceptorNameLoc",
        Cell: (row) => (
          <span>{row.cardAcceptorNameLoc.replace(/\s+/g, " ").trim()}</span>
        ),
      },
      {
        accessor: "tranAmount",
        name: "Transaction Amount",
        sortable: true,
        sortKey: "tranAmount",
      },
      {
        accessor: "tranTime",
        name: "Transaction Date/Time",
        sortable: true,
        sortKey: "tranTime",
        Cell: (row) => <span>{new Date(row.tranTime).toLocaleString()}</span>,
      },
      // {
      //     accessor: "tranPostedDatetime",
      //     name: "Posted Date/Time",
      //     sortable: true,
      //     sortKey: "tranPostedDatetime",
      // },
    ];

    const getCardStatement = (values) => {
      dispatch(searchCardStatement(values));
      
    };
    const getIssuerStatement = (values) => {
      try {
        if (values) {
          values["issuer"] = "ISSUER";
          dispatch(searchCardStatement(values));
        }
      } catch (e) {
        console.error(e);
      }
    };

    const handleDownload = (fileType) => {
      if (fileType === "CSV") {
        dispatch(
          downloadCardStatement({
            ...cardStatement.request,
            download: true,
            fileType: fileType,
          })
        );
      }
      if (fileType === "PDF") {
        dispatch(
          pdfDownloadCardStatement({
            ...cardStatement.request,
            download: true,
            fileType: fileType,
          })
        );
      }
    };

    const dropDownChange = (data) => {
      if (data.value === 1) {
        setFormsDisplay(1);
      }
      if (data.value === 2) {
        setFormsDisplay(2);
      }
      if (data.value === 3) {
        setFormsDisplay(3);
      }
    };
    const loadData = (pageNum, pageSize) => {
      dispatch(
        searchCardStatement({
          ...cardStatement.request,
          pageNum: pageNum,
          pageSize: pageSize,
        })
      );
    };

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">Search transaction report</h5>
            </div>
            <Row className="mb-3" style={{ width: "80rem" }}>
              <AccessControl
                allowedPermissions={[permissionsConstants.FETCH_ISSUER_CONFIGS]}
                renderNoAccess={() => (
                  <Col lg={2}>
                    {" "}
                    <Select
                      options={nonIssuerOptions}
                      onChange={dropDownChange}
                      defaultValue={options[0]}
                      label="key"
                      name="dropDown"
                    />
                  </Col>
                )}
              >
                <Col lg={2}>
                  <Select
                    options={options}
                    onChange={dropDownChange}
                    defaultValue={options[0]}
                    label="key"
                    name="dropDown"
                  />
                </Col>
              </AccessControl>
            </Row>
            {formsDisplay === 1 && (
              <CardStatementSearchForm
                loading={cardStatement && cardStatement.loading}
                onSubmit={getCardStatement}
              />
            )}
            {formsDisplay === 2 && (
              <CardStatementSearchByProgramForm
                loading={cardStatement && cardStatement.loading}
                onSubmit={getCardStatement}
              />
            )}
            {formsDisplay === 3 && (
              <CardStatementSearchForm
                loading={cardStatement && cardStatement.loading}
                onSubmit={getIssuerStatement}
                hideCardNumber={true}
              />
            )}
            {cardStatementData && cardStatementData.length ? (
              <AccessControl
                allowedPermissions={[
                  permissionsConstants.DOWNLOAD_CARD_STATEMENT,
                ]}
                renderNoAccess={() => null}
              >
                <Row className="text-right">
                  <Col>
                    <Button
                      onClick={() => handleDownload("CSV")}
                      disabled={cardStatementDownload.loading}
                      color="success"
                    >
                      {cardStatementDownload.loading ? (
                        <span className="mr-3">
                          <Spinner size="sm" color="default" />
                        </span>
                      ) : (
                        <AiFillFileExcel size={"1.5em"} />
                      )}
                      <span style={{ marginLeft: "11px" }}>Download</span>
                    </Button>
                    <Button
                      onClick={() => handleDownload("PDF")}
                      disabled={pdfFormatDownload.loading}
                      color="success"
                    >
                      {pdfFormatDownload.loading ? (
                        <span className="mr-3">
                          <Spinner size="sm" color="default" />
                        </span>
                      ) : (
                        <AiFillFilePdf size={"1.5em"} />
                      )}
                      <span style={{ marginLeft: "11px" }}>Download</span>
                    </Button>
                  </Col>
                </Row>
              </AccessControl>
            ) : null}

            <DataTable
              columns={columns}
              loading={cardStatement && cardStatement.loading}
              data={cardStatementData}
              permissions={permissions}
              NoDataText={
                cardStatement && cardStatement.response
                  ? "No transaction(s) found"
                  : "Please enter search criteria"
              }
              count={count}
              loadData={loadData}
              countName="transactions"
              defaultPageSize={10}
              defaultPageNumber={1}
              error={cardStatement && cardStatement.error}
              bordered={true}
              striped={true}
              hover={true}
              responsive
              serverside
            />
          </CardBody>
        </Card>
      </Col>
    );
  }
);

export default connect((state) => ({
  cardStatement: state.transactionReport,
  cardStatementDownload: state.downloadCardStatement,
  pdfFormatDownload: state.pdfDownloadCardStatement,
  permissions: state.permissions && state.permissions.response,
}))(CardStatementTable);
